@if (bottomNavigationDetails) {
  <footer>
    <div class="footer-layout">
      <div class="footer-layout-left">
        <address>
          <h3 class="footer-agency-name sub-heading-one">{{bottomNavigationDetails()?.agencyName}}</h3>
          {{bottomNavigationDetails()?.addressLine1 ? bottomNavigationDetails()?.addressLine1 + ',' : ''}}
          {{bottomNavigationDetails()?.addressLine2 ?
          bottomNavigationDetails()?.addressLine2 : ''}}
          {{bottomNavigationDetails()?.city ? bottomNavigationDetails()?.city + ',' : ''}}
          {{bottomNavigationDetails()?.state}}
          {{bottomNavigationDetails()?.zip}}<br>
          Phone: {{bottomNavigationDetails()?.formattedPhoneNumber}}
        </address>
        <p>{{year}} | Powered by EZLynx. All rights reserved.</p>
      </div>
      <div class="footer-layout-right">
        @if (socialMedia()?.facebookUrl) {
          <a [href]="socialMedia()?.facebookUrl"
             target="_blank"
             mat-button>
            <img src="assets/images/facebook-logo.png"
                 alt="facebook"
                 class="social-media-icon">
          </a>
        }
        @if (socialMedia()?.instagramUrl) {
          <a [href]="socialMedia()?.instagramUrl"
             target="_blank"
             mat-button>
            <img src="assets/images/instagram-logo.png"
                 alt="instagram"
                 class="social-media-icon">
          </a>
        }
        @if (socialMedia()?.linkedInUrl) {
          <a [href]="socialMedia()?.linkedInUrl"
             target="_blank"
             mat-button>
            <img src="assets/images/linkedin-logo.png"
                 alt="linkedin"
                 class="social-media-linkedin-icon">
          </a>
        }
        @if (socialMedia()?.xUrl) {
          <a [href]="socialMedia()?.xUrl"
             target="_blank"
             mat-button>
            <img src="assets/images/x-logo.png"
                 alt="x(twitter)"
                 class="social-media-x-icon">
          </a>
        }
        @if (socialMedia()?.youtubeUrl) {
          <a [href]="socialMedia()?.youtubeUrl"
             target="_blank"
             mat-button>
            <img src="assets/images/youtube-logo.png"
                 alt="youtube"
                 class="social-media-icon">
          </a>
        }
      </div>
    </div>
  </footer>
}